import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const scrollToContact = () => {
  const el = document.getElementById("contact");
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function FinalCTA() {
  return (
    <section id="cta" className="relative py-32 overflow-hidden">
      {/* Pulsing aura */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[900px] h-[900px] rounded-full bg-[radial-gradient(closest-side,rgba(0,122,255,0.25),rgba(139,92,246,0.18)_40%,transparent_70%)] blur-2xl animate-pulse-glow" />
      </div>
      {/* Particles */}
      <div className="absolute inset-0 pointer-events-none">
        {Array.from({ length: 18 }).map((_, i) => {
          const left = (i * 29) % 100;
          const top = (i * 41) % 100;
          const size = 2 + ((i * 3) % 4);
          return (
            <span
              key={`fcta-particle-${i}`}
              className="particle"
              style={{
                width: `${size}px`,
                height: `${size}px`,
                left: `${left}%`,
                top: `${top}%`,
                animation: `float-y ${7 + (i % 3)}s ease-in-out ${(i * 0.3) % 5}s infinite`,
                opacity: 0.6,
              }}
            />
          );
        })}
      </div>

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium text-white leading-[1.1]"
          data-testid="final-cta-heading"
        >
          Ready to Turn Your Business Into a{" "}
          <span className="bg-gradient-to-r from-[#00F0FF] via-[#007AFF] to-[#8B5CF6] bg-clip-text text-transparent">
            3X Growth System?
          </span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-6 text-white/60 text-lg max-w-2xl mx-auto"
        >
          One setup. One system. Months of wasted follow-ups — gone.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-10"
        >
          <button
            onClick={scrollToContact}
            className="btn-primary inline-flex items-center gap-2 text-base"
            data-testid="final-cta-btn"
          >
            Start Scaling Now
            <ArrowRight size={18} />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
